import { c as _c } from "react/compiler-runtime";
import classnames from 'classnames';
import { type AnchorHTMLAttributes, type ButtonHTMLAttributes, type ComponentType, type PropsWithChildren, type ReactElement } from 'react';
import { type ImageWithFallbackProps } from '../image-with-fallback/image-with-fallback';
import { Card } from './card';
import styles from './card-link.module.scss';
export type CardLinkProps = ButtonHTMLAttributes<HTMLAnchorElement> & ButtonHTMLAttributes<HTMLButtonElement> & {
  actionClassName?: string;
  className?: string;
  ImageComponent?: ReactElement<ImageWithFallbackProps>;
  LinkComponent?: ComponentType<AnchorHTMLAttributes<HTMLAnchorElement>>;
  to?: string;
};
export const CardLink = t0 => {
  const $ = _c(26);
  let ImageComponent;
  let LinkComponent;
  let actionClassName;
  let children;
  let className;
  let onClick;
  let props;
  let to;
  if ($[0] !== t0) {
    ({
      actionClassName,
      children,
      className,
      ImageComponent,
      LinkComponent,
      onClick,
      to,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = ImageComponent;
    $[2] = LinkComponent;
    $[3] = actionClassName;
    $[4] = children;
    $[5] = className;
    $[6] = onClick;
    $[7] = props;
    $[8] = to;
  } else {
    ImageComponent = $[1];
    LinkComponent = $[2];
    actionClassName = $[3];
    children = $[4];
    className = $[5];
    onClick = $[6];
    props = $[7];
    to = $[8];
  }
  let t1;
  if ($[9] !== className) {
    t1 = classnames(styles["card-link"], className);
    $[9] = className;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  let t2;
  if ($[11] !== ImageComponent) {
    t2 = ImageComponent && <ImageComponent.type {...ImageComponent.props} className={classnames([styles["card-link__image"], ImageComponent.props?.className])} height={ImageComponent.props?.height ?? 280} width={ImageComponent.props?.width ?? 280} />;
    $[11] = ImageComponent;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== children) {
    t3 = <div className={styles["card-link__content"]}>{children}</div>;
    $[13] = children;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== t1 || $[16] !== t2 || $[17] !== t3) {
    t4 = <Card className={t1} isClickable={true}>{t2}{t3}</Card>;
    $[15] = t1;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  const content = t4;
  let t5;
  if ($[19] !== LinkComponent || $[20] !== actionClassName || $[21] !== content || $[22] !== onClick || $[23] !== props || $[24] !== to) {
    t5 = to && LinkComponent !== undefined ? <LinkComponent className={classnames(styles["card-link__action"], actionClassName)} href={to} onClick={onClick} {...props}>{content}</LinkComponent> : <button className={classnames(styles["card-link__action"], actionClassName)} onClick={onClick} type="button" {...props}>{content}</button>;
    $[19] = LinkComponent;
    $[20] = actionClassName;
    $[21] = content;
    $[22] = onClick;
    $[23] = props;
    $[24] = to;
    $[25] = t5;
  } else {
    t5 = $[25];
  }
  return t5;
};